import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import logo from "../favicon.ico";

const Login = ({ setIsAuthenticated }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    // Hardcoded credentials for demonstration
    const hardcodedEmail = "admin@gmail.com";
    const hardcodedPassword = "123456";

    if (email === hardcodedEmail && password === hardcodedPassword) {
      localStorage.setItem("authToken", "dummyToken"); // Store a dummy token
      setIsAuthenticated(true);
      navigate("/dashboard"); // Redirect to dashboard after login
    } else {
      setError("Invalid email or password");
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        background:
          "linear-gradient(135deg,rgb(180, 189, 228),rgb(222, 215, 230))",
      }}
    >
      <div
        className="card shadow-lg p-4 rounded"
        style={{ width: "400px", background: "white" }}
      >
        <div className="text-center">
          <img src={logo} alt="User Icon" width="35" />
          <h3 className="mt-2 fw-bold text-primary">
            <span style={{ color: "#28338C" }}>Ship</span>
            <span style={{ color: "#FFD420" }}>Cube</span>
          </h3>
          <p className="text-muted">Sign in to continue</p>
        </div>
        {error && <div className="alert alert-danger text-center">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Email</label>
            <input
              type="email"
              className="form-control border-primary"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter email"
            />
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">Password</label>
            <input
              type="password"
              className="form-control border-primary"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter password"
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary w-100 rounded-pill fw-bold"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
